
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.548 18.611a5.302 5.302 0 10-5.524-9.052 5.302 5.302 0 005.524 9.052zm-.72-1.18a3.919 3.919 0 10-4.083-6.691 3.919 3.919 0 004.082 6.69z","fill":"#7D7D7D"}}),_c('rect',{attrs:{"x":"15.477","y":"18.184","width":"1.844","height":"6.35","rx":".922","transform":"rotate(-31.391 15.477 18.184)","fill":"#7D7D7D"}})])
          )
        }
      }
    